import { Button } from './button';
import { Input, Select, NumberInput, Textarea } from './forms';
import { Modal, Drawer, Menu, Popover, Tooltip } from './overlays';
import { Card, Badge, Tag, Heading, Tabs, Table } from './surfaces';

/** Assembled Chakra `components` override map for the theme. */
export const components = {
	Button,
	Input,
	Select,
	NumberInput,
	Textarea,
	Modal,
	Drawer,
	Menu,
	Popover,
	Tooltip,
	Card,
	Badge,
	Tag,
	Heading,
	Tabs,
	Table,
} as const;

export default components;
